const StatisticCardSkeleton = () => {
  return (
    <div className="rounded min-w-[230px] flex-1 h-[100px] flex bg-secondary-background items-center p-4 xxl:min-w-[200px]">
      <div>
        <div className="w-[50px] h-[50px] bg-secondary-skeleton rounded-full"></div>
      </div>
      <div className="ml-5 flex-2 flex flex-col space-y-2">
        <div className="w-[50px] h-[17px] min-h-[17px] bg-secondary-skeleton rounded"></div>
        <div className="w-[80px] h-[12px] min-h-[12px] bg-secondary-skeleton rounded"></div>
      </div>
    </div>
  )
}

export default StatisticCardSkeleton
